export const fr = {
  lang: 'fr',
  data: {
    'ROUTES': {
      'home': 'accueil',
      'features': 'fonctionnalites',
      'pricing': 'tarifs',
      'faq': 'faq',
      'help': 'aide',
      'forum': 'forum',
      'blog': 'blog',
      'member': 'membre',
      'login': 'connexion',
      'dashboard': 'tableau-de-bord',
      'support': 'support',
      'tickets': 'tickets',
      'register': 'inscription',
      'complete': 'finalisation',
      'download': 'telechargement',
      'contact': 'contact',
      'profile': 'profil',
      'general': 'general',
      'address': 'adresse',
      'company': 'entreprise',
      'other': 'autres',
      'subscription': 'abonnement',
      'manage': 'gerer',
      'accounts': 'comptes',
      'templates': 'modeles',
      'apps': 'apps',
      'legal': 'juridique',
      'terms': 'cgv',
      'privacy': 'confidentialite',
      'imprint': 'mentions-legales',
      'cancellation': 'resiliation',
      'error': 'erreur',
      'item-management': 'gestion-articles',
      'import-export': 'import-export',
      'synchronization': 'synchronisation',
      'orders': 'commandes',
      'messages': 'messages',
      'marketing': 'marketing',
      'extra': 'extras',
      'ai': 'ia',
      'ebay-lister': 'ebay-lister',
      'gpsr': 'gpsr',
      'car-parts': 'pieces-auto',
    },
    'LEGAL': {
      'META': {
        'TERMS': {
          'TITLE': 'CGV - dewabit',
          'DESCRIPTION': 'Les conditions générales d\'utilisation de dewabit, le logiciel de mise en vente pour les vendeurs eBay.',
        },
        'PRIVACY': {
          'TITLE': 'Politique de confidentialité - dewabit',
          'DESCRIPTION': 'Comment dewabit traite et protège les données personnelles - notre politique de confidentialité.',
        },
        'IMPRINT': {
          'TITLE': 'Mentions légales - dewabit',
          'DESCRIPTION': 'Mentions légales et identification de l\'éditeur BWS IT GmbH, éditeur de dewabit.',
        },
        'CANCELLATION': {
          'TITLE': 'Résilier les contrats ici - dewabit',
          'DESCRIPTION': 'Résiliez votre abonnement dewabit en ligne - sans connexion, avec confirmation de réception immédiate.',
        },
      },
    },
    'NAV-LINKS': {
      'HOME': 'Accueil',
      'FEATURES': 'Fonctionnalités',
      'EBAY-LISTER': 'eBay Lister',
      'GPSR': 'GPSR',
      'CARPARTS': 'Pièces auto',
      'DOWNLOAD': 'Télécharger',
      'PRICING': 'Tarifs',
      'FAQ': 'FAQ',
      'HELP-PAGES': 'Pages d\'aide',
      'FORUMS': 'Forums',
      'BLOG': 'Blog',
      'CONTACT': 'Contact',
      'LOGIN': 'Connexion',
      'REGISTER': 'S\'inscrire',
      'MEMBER': 'Espace membre',
      'MEMBER-DASHBOARD': 'Tableau de bord',
      'MEMBER-PROFILE': 'Profil',
      'MEMBER-SUBSCRIPTION': 'Votre abonnement',
      'MEMBER-EBAY-ACCOUNTS': 'Comptes ebay',
      'MEMBER-TEMPLATES': 'Modèles',
      'MEMBER-APPS': 'Apps',
      'MEMBER-SUPPORT': 'Support',
      'IMPRINT': 'Mentions légales',
      'CANCELLATION': 'Résilier les contrats ici',
      'PRIVACY': 'Confidentialité',
      'TERMS': 'CGV',
      'LOGOUT': 'Déconnexion',
      'ACCOUNT-MENU': 'Menu du compte',
    },
    'GLOBAL': {
      'ERROR': 'Erreur',
      'ERROR-GENERAL': 'Une erreur est survenue. Veuillez réessayer plus tard ou contacter notre support.',
      'SESSION-EXPIRED': 'Votre session a expiré, veuillez vous reconnecter',
      'CANCEL': 'Annuler',
      'TRY-AGAIN': 'Réessayer',
      'PLEASE-WAIT': 'Veuillez patienter',
      'ARE-YOU-SURE': 'Êtes-vous sûr ?',
      'SUCCESS': 'Succès',
      'DELETE': 'Supprimer',
      'WARNING': 'Attention',
      'INFO': 'Info',
      'CHARS-LEFT': 'caractères restants',
      'CLOSE': 'Fermer',
      'CLOSE-WINDOW': 'Fermer la fenêtre',
      'COPY-TO-CLIPBOARD': 'Copier dans le presse-papiers',
      'YES': 'Oui',
      'NO': 'Non',
      'CONFIRM': 'Confirmer',
      'SELECT': 'Sélectionner',
      'ACTIVE': 'Actif',
      'INACTIVE': 'Inactif',
      'DEFAULT': 'Par défaut',
      'SAVE-CHANGES': 'Enregistrer les modifications',
      'FOOTER': {
        'IMPRINT': 'Mentions légales',
        'PRIVACY': 'Confidentialité',
        'TERMS': 'CGV',
      },
      'UPDATE-AVAILABLE': {
        'HEAD': 'Mise à jour disponible !',
        'BODY': 'Une nouvelle version est disponible. Voulez-vous recharger la page maintenant ? Attention : ' +
          'les modifications non enregistrées seront perdues.',
        'LATER': 'Plus tard',
        'RELOAD': 'Recharger la page',
      },
      'WEBSOCKET': {
        'TICKET-REPLY': 'Vous avez reçu une réponse à votre ticket de support.'
      },
      'PAYMENT': {
        'SUBTOTAL': 'Sous-total hors TVA',
        'VAT': '{{VATPERCENT}}% de TVA sur',
        'TOTAL': 'Total',
        'AMOUNT-TO-PAY': 'Montant à payer',
        'CB-TERMS': 'J\'ai lu les conditions générales et je les accepte',
        'OPEN-NEW-WINDOW': 'Ouvrir dans une nouvelle fenêtre',
        'CB-CANCELLATION': 'Je demande et j\'accepte que vous commenciez la prestation commandée avant l\'expiration du délai de rétractation. ' +
          'Je sais que mon droit de rétractation expire avec l\'exécution complète du contrat.',
        'CONTINUE-PAYPAL': 'Continuer vers PayPal',
      },
      'LOGIN-MODAL': {
        'HEAD': 'Veuillez saisir vos identifiants dewabit pour vous connecter :',
        'E-MAIL': 'E-mail',
        'E-MAIL-PLACEHOLDER': 'Saisir l\'adresse e-mail',
        'PASSWORD': 'Mot de passe',
        'PASSWORD-PLACEHOLDER': 'Saisir le mot de passe',
        'LOGIN': 'Connexion',
        'LOGIN-SUCCESS': 'Connexion réussie',
      },
      'COMMUNITY-PUSH': {
        'NEW-POST': 'Nouveau message de {{user}}',
        'NEW-THREAD': 'Nouveau sujet de {{user}} : {{threadName}}',
      },
      'LOGOUT-SUCCESS': 'Vous avez été déconnecté avec succès',
      'CTA-REGISTER': {
        'CTA-HEAD': 'Créez votre compte gratuit dès maintenant !',
        'CTA-BODY': 'Inscription et essai sans risque, sans indication de moyen de paiement',
        'CTA-BTN': 'S\'inscrire maintenant',
      }
    }
  },
};
